import React from 'react';
import { User } from '../types';
import AddExpense from '../pages/AddExpense';
import ModalSheet from './ModalSheet';

interface AddExpenseModalProps {
  user: User;
  isOpen: boolean;
  onClose: () => void;
  forceGroupId?: string; // Optional: force a specific group
}

const AddExpenseModal: React.FC<AddExpenseModalProps> = ({ user, isOpen, onClose, forceGroupId }) => {
  return (
    <ModalSheet
      isOpen={isOpen}
      onClose={onClose}
      title="Add Expense"
      showCloseButton={true}
      fullScreen
    >
      <div className="add-expense-modal-content">
        <AddExpense user={user} isModal onClose={onClose} forceGroupId={forceGroupId} />
      </div>
    </ModalSheet>
  );
};

export default AddExpenseModal;

